export default class GoogleMap {
  constructor(element) {
    this.el = element
    this.street = this.el.dataset.street;
    this.city = this.el.dataset.city;
    this.init()
  }

  init() {
    let address = `${this.street}, ${this.city}`
    let googleframe = `<iframe class="w-full sm:w-1/2" width='425' height='350' frameborder='0' scrolling='no' marginheight='0' marginwidth='0' src='https://maps.google.com/maps?&amp;q="${encodeURIComponent(address)}&amp;output=embed'></iframe>`
    this.el.innerHTML = googleframe;
  }
}
